import GradientText from '../Gradients/GradientText';
import { FC } from 'react';
import { GRADIENTS, Gradient } from '../../config/designSystem/Colors';
import { SPACING } from '../../config/designSystem/Spacing';
import { TouchableOpacity, View } from 'react-native';


export interface ToggleNotSelectedElementProps {
    label:string;
    onPress: () => void;
  }


export const ToggleNotSelectedElement: FC<ToggleNotSelectedElementProps>= ({label, onPress} : ToggleNotSelectedElementProps) => {
  return(
    <TouchableOpacity
      onPress={onPress}>
      <View  style={{
        borderRadius: SPACING['sp-8'],
        paddingVertical: SPACING['sp-8'],
        paddingHorizontal: SPACING['sp-12'],
        alignItems:'center'

      }} >


        <View style={{      alignItems:'center'}} >


          <GradientText gradient={GRADIENTS.brand['primary-light'] as Gradient} label={label} typo={'Title3'}/>

        </View>
      </View>
    </TouchableOpacity>
  );



};



